import { render, staticRenderFns } from "./PostCreation_TagSelection.vue?vue&type=template&id=4de0bf8b&scoped=true&"
import script from "./PostCreation_TagSelection.vue?vue&type=script&lang=js&"
export * from "./PostCreation_TagSelection.vue?vue&type=script&lang=js&"
import style0 from "./PostCreation_TagSelection.vue?vue&type=style&index=0&id=4de0bf8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0bf8b",
  null
  
)

export default component.exports